import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

interface ImportLoadingModalProps {
  open: boolean;
}

const ImportLoadingModal: React.FC<ImportLoadingModalProps> = ({ open }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 4,
          }}
        >
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            {t('import.loading.title')}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            {t('import.loading.description')}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImportLoadingModal;
